import AScene from "../../library/ExtendedObjects/AScene.js";
import Backgrounds from "../Backgrounds.js";
import GameMenu from "../GameMenu.js";
import gameData from "../../gameData.js";
import ABCyaLib from "@abcya/abcya_lib";

export default class Descriptions extends AScene
{
    create()
    {
        this.background = new Backgrounds(this);
        this.background.displayBG(gameData.backgroundClasses.moneyBG, false);

        this.goldPig = this.addSpine(this.mid.x - 30, 1024, "Pig", "GoldPig_Idle", true);
        this.goldPig.spine.setScale(1.4);
        this.goldPig.addDropShadow(15, 20);
        
        this.menu = new GameMenu(this, true);
        this.leftArrow = this.addDropShadow(this.addButton(50, 290, "Btn_ArwLeft", ()=>{
            this.setNextDenomination(-1);
        }), 3, 4);
        this.rightArrow = this.addDropShadow(this.addButton(this.size.width - 50, 290, "Btn_ArwRt", ()=>{
            this.setNextDenomination(1);
        }), 3, 4);
        this.playBtn = this.addDropShadow(this.addButton(883, 50, "Btn_SkipAll", ()=>{
            this.animateOut();
        }), 3, 4);

        this.denominations = [];
        const config = ABCyaLib.Environment.instance.gameConfig;
        if(gameData.denominations === gameData.denominationTypes.CUSTOM && config.customDenominations !== null)
        {
          this.denominations = Object.keys(config.customDenominations);
          this.leftArrow.setVisible(this.denominations.length > 1);
          this.rightArrow.setVisible(this.denominations.length > 1);
        }
        else{
          if(gameData.denominations == gameData.denominationTypes.COINS || gameData.denominations == gameData.denominationTypes.COINS_DOLLARS)
            this.denominations = this.denominations.concat(Object.keys(gameData.coinData));
          if(gameData.denominations == gameData.denominationTypes.DOLLARS || gameData.denominations == gameData.denominationTypes.COINS_DOLLARS)
            this.denominations = this.denominations.concat(Object.keys(gameData.dollarData));
        }
        this.descriptionText = this.addText(this.mid.x + 10, 670, 32, 0xA86E07, gameData.fonts.comfortaa_bold, "Information about the test current currency",)
        this.descriptionText.setWordWrapWidth(650);
        this.descriptionText.setDepth(3);

        this.denominationIndex = 0;
        this.curDenomination = null;

        gameData.curProgress = 0;
        gameData.curBackground = "moneyBG";
        this.descriptionSound = null;

        this.animateIn();
        this.setNextDenomination(0);
    }

    animateIn()
    {
        let pigY = this.goldPig.spine.y;
        let descriptionY = this.descriptionText.y;

        this.goldPig.spine.y = 1400;
        this.descriptionText.y = 1046;
        this.playBtn.setScale(0);
        this.playBtn.alpha = 0;
        this.menu.menuBtn.alpha = 0;
        this.menu.menuBtn.setScale(0);
        this.leftArrow.alpha = 0;
        this.leftArrow.setScale(0);
        this.rightArrow.alpha = 0;
        this.rightArrow.setScale(0);

        this.addTween(this.goldPig.spine, 800, {y: pigY, easeParams: [1, 1]}, "Elastic");
        this.addTween(this.descriptionText, 800, {y: descriptionY, easeParams: [1, 1]}, "Elastic");
        this.addTween([this.playBtn, this.menu.menuBtn, this.leftArrow, this.rightArrow], 500, {alpha: 1, scaleX: 1, scaleY: 1}, "Back");
    }

    animateOut()
    {
        if(this.descriptionSound != null) this.descriptionSound.destroy();
        let btns = [this.playBtn, this.leftArrow, this.rightArrow];
        this.killTween([this.goldPig.spine, this.descriptionText, this.curDenomination.spine].concat(btns));

        this.addTween(this.goldPig.spine, 400, {y: 1400}, Phaser.Math.Easing.Sine.Out);
        this.addTween(this.descriptionText, 400, {y: 1046}, Phaser.Math.Easing.Sine.Out);
        this.addTween(this.curDenomination.spine, 300, {scaleX: 0, scaleY: 0}, Phaser.Math.Easing.Sine.Out);
        this.addTween(btns, 400, {alpha: 0, scaleX: 0, scaleY: 0}, Phaser.Math.Easing.Sine.Out, ()=>{
            this.scene.start(gameData.gameType == gameData.gameTypes.COUNTING ? "Game_Counting" : "Game_Sorting");
        });
    }

    setNextDenomination(modifier)
    {
        if(this.curDenomination != null)
        {
            this.animateDenominationOut(this.curDenomination);
        }

        let data = this.getNextDenominationData(modifier);
        this.curDenomination = this.addDenomination(data);

        this.killTween(this.descriptionText);
        this.playSound("tweens");
        if(this.descriptionSound != null) this.descriptionSound.destroy();
        this.descriptionSound = this.playSound(data.name)
        this.addTween(this.descriptionText, 200, {alpha: 0}, Phaser.Math.Easing.Sine.Out, ()=>{
            this.descriptionText.text = data.description;
            this.addTween(this.descriptionText, 300, {alpha: 1}, Phaser.Math.Easing.Sine.Out);
        });

        this.animateDenominationIn(this.curDenomination);
    }

    animateDenominationOut(denomination)
    {
        this.killTween(denomination);
        if(denomination.data.isCoin)
        {
            denomination.play("flipForward", false, null, 6);
            this.addTween(denomination.spine, 800, {y: 800, scaleX: .5, scaleY: .5}, Phaser.Math.Easing.Sine.Out, ()=>{
                denomination.destroy();
            });
        }
        else
        {
            denomination.play("fold", false, null, 2);
            this.addTween(denomination.spine, 800, {y: 700, scaleX: .5, scaleY: .5}, Phaser.Math.Easing.Sine.InOut, ()=>{
                denomination.destroy();
            });
        }
    }

    animateDenominationIn(denomination)
    {
        this.killTween(denomination);
        denomination.spine.y = -300;

        if(denomination.data.isCoin)
        {
            denomination.play("flipForward", false, null, 5);
            this.addTween(denomination.spine, 1200, {y: 280, easeParams: [1, 1], delay: 200}, "Elastic");
        }
        else
        {
            denomination.play("unfold");
            this.addTween(denomination.spine, 1200, {y: 280, easeParams: [1, 1], delay: 200}, "Elastic");
        }
    }

    getNextDenominationData(modifier)
    {
        let denominationData = null;

        this.denominationIndex += modifier;
        if(this.denominationIndex >= this.denominations.length) this.denominationIndex = 0;
        else if(this.denominationIndex < 0) this.denominationIndex = this.denominations.length - 1;

        let key = this.denominations[this.denominationIndex];
        if(isNaN(Number.parseInt(key))) //We're a coin
        {
            denominationData = gameData.coinData[key];
            denominationData.isCoin = true;
        }
        else //We're a dollar
        {
            denominationData = gameData.dollarData[key];
            denominationData.isCoin = false;
        }
        denominationData.name = key;

        return denominationData;
    }

    addDenomination(data)
    {
        let denomination = this.addSpine(this.mid.x, 280, data.isCoin ? "coin" : "dollar", data.isCoin ? "flipForward" : "unfold", true);
        denomination.setSkin(data.name);
        denomination.addDropShadow(5, 5);
        if(data.isCoin) denomination.spine.setScale(2);
        denomination.play(data.isCoin ? "flipForward" : "unfold", true, null, 0);
        denomination.data = data;

        this.addPathMask([denomination.spine, denomination.shadowSpine], 421, 568, [
            -20, -2,
            50, 4,
            100, 5,
            150, 2,
            200, -4,
            200, 300,
            -20, 300, 
        ], false);

        denomination.shadowSpine.mask.invertAlpha = true;
        denomination.spine.mask.invertAlpha = true;

        return denomination;
    }
}